export function formatPlacedOrigin(placedOrigin?: string): string {
  if (placedOrigin === "ConsumerApp") {
    return "VIA APLICATIVO";
  }

  if (
    placedOrigin === "DealerWhatsApp" ||
    placedOrigin === "ConsumerWhatsApp"
  ) {
    return "VIA WHATSAPP";
  }

  if (placedOrigin === "DealerStore" || placedOrigin === "DriverStore") {
    return "VIA PORTARIA";
  }

  return "Não informado";
}
